module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("User / Employees Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("New User")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('All_Users_Report', 'Export')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('PurchaseApproverDetails', {
    staticClass: "ml-3",
    attrs: {
      "showButton": true,
      "payload": _vm.purchaseApproverPayload
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "9"
    }
  }, [_c('label', [_vm._v("Common")]), _vm._v(" "), _c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": function($event) {
        _vm.filter = '';
        _vm.ClearFilter();
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.$store.getters['common/getAllBranchList'],
      "selected-options": _vm.branch_items,
      "placeholder": "Select Branch",
      "multiple": true,
      "id": "Client",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "select": _vm.SelectMultiBranch
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-row', {
    staticClass: "align-content-end mt-3"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.vehicleSizeMaster)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.AllUserIds.length) + ")")]), _vm._v(" "), (_vm.AllUserIds.length > 0) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.ShowModalUser
    }
  }, [_vm._v("Add Client")]) : _vm._e(), _vm._v(" "), (_vm.AllUserIds.length > 0) ? _c('Send-Email', {
    attrs: {
      "AgentId": _vm.AllUserIds,
      "AllEmailId": _vm.AllEmailId,
      "type": 'User'
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.vehicleSizeMaster,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "isActive",
      fn: function(row0) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.AllUserIds),
            expression: "AllUserIds"
          }],
          attrs: {
            "type": "checkbox",
            "id": row0.item.DepartmentId
          },
          domProps: {
            "value": row0.item.userId,
            "checked": Array.isArray(_vm.AllUserIds) ? _vm._i(_vm.AllUserIds, row0.item.userId) > -1 : (_vm.AllUserIds)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.AllUserIds,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = row0.item.userId,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.AllUserIds = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.AllUserIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.AllUserIds = $$c
              }
            }, function($event) {
              _vm.updateSelectAll($event, row0.item)
            }]
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "employeeName",
      fn: function(row11) {
        return [(row11.item.type == '1') ? _c('div', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewUserPage(row11.item.userId)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(row11.item.employeeName))])]) : _c('div', {
          on: {
            "click": function($event) {
              _vm.viewUserPage(row11.userId)
            }
          }
        }, [_c('span', [_vm._v("Client Name : " + _vm._s(row11.item.clientName))])])]
      }
    }, {
      key: "username",
      fn: function(row1) {
        return [(row1.item.type == '1') ? _c('div', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewUserPage(row1.item.userId)
            }
          }
        }, [_c('span', [_vm._v("Emp-username : " + _vm._s(row1.item.username))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Emp-Code :" + _vm._s(row1.item.employeeCode))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Emp-Designation: " + _vm._s(row1.item.designation))])]) : _c('div', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewUserPage(_vm.item1.userId)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(row1.item.username))])])]
      }
    }, {
      key: "acc_client_ids",
      fn: function(row3) {
        return [_c('b-button', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.viewClients(row3.item)
            }
          }
        }, [_vm._v("View Clients")]), _vm._v(" "), (row3.item.userId) ? _c('userBasedClient', {
          attrs: {
            "PMC_title": 'User Summary - ' + row3.item.employeeName,
            "PMC_USERID": row3.item.userId,
            "PMC_USERNAME": row3.item.username,
            "PMC_USERDESIG": row3.item.designation,
            "PMC_BranchClientPre": row3.item.branchclientPre,
            "PMC_TransportTypePre": row3.item.transportTypePre,
            "PMC_UserEmpName": row3.item.employeeName,
            "PMC_UserEmpCode": row3.item.employeeCode
          }
        }) : _vm._e()]
      }
    }, {
      key: "userId",
      fn: function(row2) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row2.item.userId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row2.item.userId,
            "name": "approval",
            "value": row2.item.isActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row2.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row2.item.isActive == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row2.item.userId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row2.item.isActive == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }, {
      key: "email",
      fn: function(row3) {
        return [_c('span', [_vm._v("Contact No. : " + _vm._s(row3.item.mobileNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Email-Address :" + _vm._s(row3.item.email))])]
      }
    }, {
      key: "show_details",
      fn: function(row4) {
        return [_c('b-form-checkbox', {
          on: {
            "change": row4.toggleDetails
          },
          model: {
            value: (row4.detailsShowing),
            callback: function($$v) {
              _vm.$set(row4, "detailsShowing", $$v)
            },
            expression: "row4.detailsShowing"
          }
        })]
      }
    }, {
      key: "row-details",
      fn: function(row4) {
        return [_c('b-card', {
          staticStyle: {
            "background": "whiteSmoke"
          }
        }, [_c('b', [_vm._v("Access Given For :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row4.item.departmentName1) + "\n                " + _vm._s(row4.item.finalPagePermision))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Created On :")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row4.item.loginTime))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "user-modal",
    attrs: {
      "id": "user-modal",
      "title": "Add User Client Details",
      "size": "lg",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("\n          Client\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.$store.getters['common/getAllMultiClientList'],
      "selected-options": _vm.client_items,
      "placeholder": "Select Client",
      "multiple": true,
      "id": "Client"
    },
    on: {
      "select": _vm.SelectMultiClient
    },
    model: {
      value: (_vm.clientUserForm.fk_multi_client_id),
      callback: function($$v) {
        _vm.$set(_vm.clientUserForm, "fk_multi_client_id", $$v)
      },
      expression: "clientUserForm.fk_multi_client_id"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.SaveUser
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.HideModalUser
    }
  }, [_vm._v("\n      Close")])], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74b983f2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/userManagement/viewUserDetail.vue
// module id = 2751
// module chunks = 0